import React, { useEffect, useState } from "react";
import LoadingScreen from "@/components/proof/LoadingScreen";
import Hero from "@/components/proof/Hero";
import OurTwoSections from "@/components/proof/OurTwoSections";
import HomeCTASection from "@/components/proof/HomeCTASection";
import PlayfulMinds from "@/components/proof/PlayfulMinds";
import Showreel from "@/components/proof/Showreel";
import Topics from "@/components/proof/Topics";
import ScrollDownIndicator from "@/components/proof/ScrollDownIndicator";

const LOADER_SESSION_KEY = "proof:loader-seen";

/**
 * Home — the original cinematic landing experience.
 * The header/footer come from the parent layout. The first time per session
 * the loader plays; subsequent visits within the session skip it for snappy nav.
 */
export default function Home() {
    const [ready, setReady] = useState(() => {
        if (typeof window === "undefined") return false;
        return window.sessionStorage.getItem(LOADER_SESSION_KEY) === "1";
    });
    const [nearBottom, setNearBottom] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            const h = document.documentElement;
            const max = h.scrollHeight - h.clientHeight;
            setNearBottom(max - h.scrollTop < 320);
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const showLoader =
        typeof window !== "undefined" &&
        window.sessionStorage.getItem(LOADER_SESSION_KEY) !== "1";

    return (
        <>
            {showLoader && (
                <LoadingScreen
                    onComplete={() => {
                        setReady(true);
                        try {
                            window.sessionStorage.setItem(
                                LOADER_SESSION_KEY,
                                "1",
                            );
                        } catch (e) {
                            /* ignore */
                        }
                    }}
                />
            )}
            <ScrollDownIndicator visible={ready && !nearBottom} />
            <main data-testid="home-main">
                <Hero ready={ready} />
                <OurTwoSections />
                <HomeCTASection />
                <PlayfulMinds />
                <Showreel />
                <Topics />
            </main>
        </>
    );
}
